<div
  class="cursor-pointer py-10px h-100 d-flex justify-content-center align-items-center"
  (click)="clearNavigationHistory()"
  [routerLink]="[link]"
  [queryParams]="{ stepNum: null }"
  [routerLinkActive]="['fc-blue']"
  queryParamsHandling="merge"
>
  <ng-content></ng-content>
</div>
